export type CustomerRole = 'staff' | 'manager' | 'case_worker' | null

type ProfileLike = {
  is_staff: boolean,
  admin_customer_ids: string[],
  case_worker_customer_ids: string[],
}

/**
 * The single place the manager/case-worker distinction is derived on the FE —
 * mirrors the api's getCustomerRole: managers are admins without the flag.
 */
export const getCustomerRole = (profile: ProfileLike, customerId: string | undefined): CustomerRole =>
  customerId == null || customerId === '' ? null
    : profile.is_staff ? 'staff'
      : !profile.admin_customer_ids.includes(customerId) ? null
        : profile.case_worker_customer_ids.includes(customerId) ? 'case_worker'
          : 'manager'
